import * as T from './types'

const mutations = {
    [T.SET_WORKSPACE_LIST](state, payload) {
        state.list = payload
    },
    [T.SET_WORKSPACE_COMPONENTS_LIST](state, payload) {
        state.componentList = payload
    },
    [T.SET_APP_INFO](state, payload) {
        state.appInfo = payload
    },
    [T.SET_CURRENT_WORKSPACE](state, payload) {
        state.current = payload
    },
    [T.SET_ROLES_LIST](state, payload) {
        state.rolesList = payload
    },
    [T.UPDATE_WORKSPACE_LOADING](state, payload) {
        state.loading = payload
    },
}

export default mutations
